import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {Control, UseFormRegister} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {IState} from "../../../../queries/pharmacy/pharmacyModel";
import {FormControl} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {Controller} from "react-hook-form";


interface PhysicalAddressProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  control: Control<any>;
  states: IState[];
}

const PhysicalAddress:React.FunctionComponent<PhysicalAddressProps> = ({
  register,
  errors,
  control,
  states
  }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={12}>
        <TextField
          label="Physical Address"
          id="physicalAddress"
          fullWidth
          required
          helperText={errors.physicalAddress?.message?.toString()}
          {...register('physicalAddress')}
          error={!!errors.physicalAddress}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <TextField
          label="City"
          id="city"
          fullWidth
          required
          helperText={errors.city?.message?.toString()}
          {...register('city')}
          error={!!errors.city}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Controller
          name="state"
          control={control}
          defaultValue=''
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id="state-label">State</InputLabel>
              <Select
                {...field}
                labelId="state-label"
                id="state"
                label="State"
                fullWidth
                required
                {...register('state')}
                error={!!errors.state}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                {states.map((state: IState) => (
                  <MenuItem key={state.id} value={state.id}>{state.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
      <TextField
        autoComplete="zipCode"
        label="Zip Code"
        id="zipCode"
        fullWidth
        required
        helperText={errors.zipCode?.message?.toString()}
        {...register('zipCode')}
        error={!!errors.zipCode}
      />
    </Grid>
    </Grid>
  )
}

export default PhysicalAddress;